'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLazyLoadImageComponent = require('react-lazy-load-image-component');

var _emptyImg = require('../../../img/empty-img.png');

var _emptyImg2 = _interopRequireDefault(_emptyImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CardItemRow = function (_React$Component) {
	_inherits(CardItemRow, _React$Component);

	function CardItemRow() {
		_classCallCheck(this, CardItemRow);

		return _possibleConstructorReturn(this, (CardItemRow.__proto__ || Object.getPrototypeOf(CardItemRow)).apply(this, arguments));
	}

	_createClass(CardItemRow, [{
		key: 'handleMenuClick',
		value: function handleMenuClick(e) {
			e.preventDefault();
			this.props.callBackParent();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'a',
				{ role: 'button', href: '#', className: 'menuAnchortag', onClick: function onClick(event) {
						return _this2.handleMenuClick(event);
					}, tabIndex: 10 },
				_react2.default.createElement(
					'div',
					{ className: "card offer-card-horizontal border-0 shadow-sm", role: 'button', tabIndex: 0, onClick: this.handleMenuClick.bind(this) },
					_react2.default.createElement(
						'div',
						{ className: "row" },
						_react2.default.createElement(
							'div',
							{ className: 'col-8 col-md-8' },
							_react2.default.createElement(
								'div',
								{ className: 'card-body' },
								_react2.default.createElement(
									'h6',
									{ className: 'font-weight-bold' },
									this.props.title
								),
								this.props.subTitle ? _react2.default.createElement(
									'p',
									{ className: 'card-text mb-2' },
									this.props.subTitle
								) : "",
								_react2.default.createElement(
									'p',
									{ className: 'mb-0 ft-14' },
									_react2.default.createElement(
										'span',
										{ className: 'color-styl' },
										'$',
										this.props.price
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-4 col-md-4 p-4 row-item-img' },
							_react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
								src: this.props.itemImageURL,
								placeholderSrc: _emptyImg2.default,
								className: this.props.imageClassName
								// width={600} height={400}
								, alt: this.props.imageAlt
							})
						)
					)
				)
			);
		}
	}]);

	return CardItemRow;
}(_react2.default.Component);

CardItemRow.propTypes = {
	title: _propTypes2.default.string.isRequired,
	itemImageURL: _propTypes2.default.string.isRequired,
	subTitle: _propTypes2.default.string,
	imageAlt: _propTypes2.default.string,
	imageClassName: _propTypes2.default.string
};
CardItemRow.defaultProps = {
	subTitle: '',
	imageAlt: '',
	imageClassName: ''
};

exports.default = CardItemRow;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/CardItemRow.jsx
// module id = 533
// module chunks = 0